// 🎬 Configuration API - CinéStream
// Change USE_NEW_API pour basculer entre ancien PHP et nouvelle API Laravel

export const API_CONFIG = {
    // 🔥 FLAG DE BASCULE : false = ancien PHP, true = nouvelle API Laravel
    USE_NEW_API: true,

    // URLs
    OLD_API_BASE: '/api',  // Ton ancien système PHP
    NEW_API_BASE: 'https://backend.popmovie.fr/api',  // Nouvelle API Laravel

    // Options de requête par défaut
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },

    // Cache-busting (pour forcer le refresh)
    CACHE_BUSTING: true,
};

// Helper pour obtenir l'URL de base selon le flag
export const getApiBaseUrl = () => {
    return API_CONFIG.USE_NEW_API ? API_CONFIG.NEW_API_BASE : API_CONFIG.OLD_API_BASE;
};

// Helper pour générer un timestamp (cache-busting)
export const getCacheBustingParam = () => {
    return API_CONFIG.CACHE_BUSTING ? `_t=${new Date().getTime()}` : '';
};